import $i18n from 'panda-i18n';
import locale from '../locale';
$i18n.addLocale(locale);
